import { ColumnState, GridApi, GridReadyEvent } from 'ag-grid-community';

export interface TachoColumnState {
    colId: string;
    sort?: 'asc' | 'desc' | null | undefined;
    sortIndex?: number | null;
    width?: number;
    hide?: boolean;
    flex?: number;
}

export const createTachoColumnState = (agGridColumnState: Array<ColumnState>) => {
    const tachoColumnState: Array<TachoColumnState> = [];
    for (const column of agGridColumnState) {
        if (column.colId) {
            tachoColumnState.push({
                colId: column.colId,
                sort: column.sort || undefined,
                sortIndex: column.sortIndex !== undefined && column.sortIndex !== null ? column.sortIndex : undefined,
                hide: column.hide || false,
                width: column.width,
                flex: column.flex || undefined,
            });
        }
    }
    return tachoColumnState;
};

export const applyColumnSortStateFromTachoPrefs = (api: GridApi, prefs: Array<TachoColumnState>) => {
    if (!prefs.length) {
        return;
    }
    if (!prefs.some(p => p.sort != null)) {
        return;
    }
    const state: Array<ColumnState> = prefs.map(p => ({
        colId: p.colId,
        sort: p.sort ?? null,
        sortIndex: p.sortIndex ?? null,
    }));
    api.applyColumnState({
        state,
        applyOrder: false,
    });
};

export const setDefaultSort = (params: GridReadyEvent, state: Array<ColumnState>, columnState: Array<TachoColumnState>) => {
    const api = params.api;
    if (columnState?.every(column => column.sort === undefined || column.sort === null)) {
        api.applyColumnState({
            state: state,
        });
    }
};

export const applyInitialSortFromDisplayPreferences = (
    params: GridReadyEvent,
    displayPreferences: Array<TachoColumnState>,
    defaultSortState: Array<ColumnState>,
) => {
    const hasSavedSort = displayPreferences.some(p => p.sort != null);
    if (hasSavedSort) {
        applyColumnSortStateFromTachoPrefs(params.api, displayPreferences);
    } else {
        setDefaultSort(params, defaultSortState, displayPreferences);
    }
};
